import { IEndereco } from "../../core/interfaces/IEndereco";
import { IClienteProgramaFidelidade } from "./IClienteProgramaFidelidade";

export interface ICliente {
    uuid?: string;
    nome: string;
    email?: string;
    cpf?: string;
    telefone?: string;
    enderecos?: IEndereco[];
    observacao?: string;
    estabelecimentoUuid?: string;
    cadastradoAs?: string;
    programasFidelidade?: IClienteProgramaFidelidade[];

    /** Dados fiscais usados como destinatário na emissão de NF-e (modelo 55). */
    tipoPessoa?: TipoPessoaCliente;
    cnpj?: string;
    razaoSocial?: string;
    inscricaoEstadual?: string;
    indicadorInscricaoEstadual?: IndicadorInscricaoEstadual;
}

export enum TipoPessoaCliente {
    FISICA = "FISICA",
    JURIDICA = "JURIDICA",
}

/** indIEDest da NF-e 4.00. */
export enum IndicadorInscricaoEstadual {
    CONTRIBUINTE = "1",
    ISENTO = "2",
    NAO_CONTRIBUINTE = "9",
}

export const IndicadorInscricaoEstadualDescricao: Record<IndicadorInscricaoEstadual, string> = {
    [IndicadorInscricaoEstadual.CONTRIBUINTE]: "Contribuinte do ICMS",
    [IndicadorInscricaoEstadual.ISENTO]: "Contribuinte isento de inscrição",
    [IndicadorInscricaoEstadual.NAO_CONTRIBUINTE]: "Não contribuinte",
};